import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 招标采购 - 直接采购
 */
export default {
  path: 'direct',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '直接采购',
    icon: 'icon-side_enterprise_info',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [{ companyType: companyTypeDict.ENTERPRISE.value }],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 采购列表
    {
      path: 'list',
      name: `DirectPurchaseList`,
      component: '/procure-views/direct-purchase/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '采购列表',
        cache: true,
        hidden: true,
        pageComponentName: 'DirectPurchaseList'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 发布直接采购
    {
      path: 'orders/:orderId?/projects/:projectId?/copy/:copyId?/publish',
      name: `DirectPurchaseForm`,
      component: '/procure-views/direct-purchase/form',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '发布直接采购',
        hidden: true,
        needFormKey: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 项目详情
    {
      path: ':orderId/detail',
      name: `DirectPurchaseDetail`,
      component: '/procure-views/direct-purchase/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
